import React from "react";
import PropTypes from "prop-types";
import { getLinkToProject } from "../../common/util/pathUtils";

const SingleColumn = ({ project, showLearnMore }) => {
    const linkToProject = getLinkToProject(project.code);

    return <div className="w-100 con-justify text-left shadow">
					<div className="up">
						<div className="img-cover img-1 w-100">
							<a href={linkToProject}><img src={project.thumbnailImageUrl} /></a>
						</div>
						<div className="px-30 py-2">
							<h6 className="text-primary">{project.locationDescription}</h6>
							<h4><a href={linkToProject} className="text-secondary">{project.name}</a></h4>
							<p className="text-grey xsml mt-0">{project.shortDescription}</p>
						</div>
					</div>
					<div className="down px-30">
						{showLearnMore &&
						<a href={linkToProject} className="text-primary">Learn more
							<img className="ml-2" src={`https://res.cloudinary.com/carbonclick/image/upload/v1628835589/Enterprise/earthshare/arow_wqx18m.svg`} />
						</a>
						}
					</div>
				</div>
}

SingleColumn.propTypes = {
    project: PropTypes.object,
    showLearnMore: PropTypes.bool
}

export default SingleColumn;